import { render } from "./CdnStatsActions.vue?vue&type=template&id=3057b121&lang=pug"
import script from "./CdnStatsActions.vue?vue&type=script&lang=js"
export * from "./CdnStatsActions.vue?vue&type=script&lang=js"

import "./CdnStatsActions.vue?vue&type=style&index=0&id=3057b121&lang=sass"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__